import type { SetStateAction } from 'react'
import { useState } from 'react'

import type { FormikErrors } from 'formik'

import {
  Button,
  FormattedMessage,
  Tooltip,
  showSnackbar,
} from '@b-stock/fe-core/bstock-react'

import type { OfferingFormData } from '../types'

const ns = 'Offerings.Details.form.offerAll'

export const OfferAllButton = ({
  setValues,
  values,
}: {
  setValues: (
    values: SetStateAction<OfferingFormData>,
    shouldValidate?: boolean
  ) => Promise<void | FormikErrors<OfferingFormData>> // eslint-disable-line @typescript-eslint/no-invalid-void-type
  values: OfferingFormData
}) => {
  const [refElem, setRefElem] = useState<HTMLButtonElement | null>(null)
  const { itemRows } = values

  const onClick = () => {
    const firstItem = itemRows[0]
    if (!firstItem?.offerAmount) {
      showSnackbar({
        content: <FormattedMessage id={`${ns}.error`} />,
        options: { autoClose: true, type: 'error' },
      })
      return
    }
    const { offerAmount } = firstItem
    void setValues({
      ...values,
      itemRows: itemRows.map((o) => ({ ...o, offerAmount })),
    })
    showSnackbar({
      content: <FormattedMessage id={`${ns}.success`} />,
      options: { autoClose: true, type: 'default' },
    })
  }

  return (
    <Button
      appearance="plainTertiary"
      onClick={onClick}
      ref={setRefElem}
      type="button"
    >
      <FormattedMessage id={`${ns}.cta`} />
      <Tooltip referenceElement={refElem}>
        <FormattedMessage id={`${ns}.tooltip`} />
      </Tooltip>
    </Button>
  )
}
